const shared = {
  home: "الرئيسية",
  events: "الفعاليات",
  employees: "الموظفين",
  reports: "التقارير",
  finance: "المالية",
  report_not_found: "لم يتم العثور على التقارير",
  logistics: "اللوجستيات",
  requests: "الطلبات",
  joiningEvents: "الالتحاق بالفعاليات",
  promotions: "الترقية",
  applicants: "المتقدمين",
  payroll: "الرواتب",
  payrollEvent: "بواسطة الأحداث",
  payrollApplicants: "حسب المتقدمين",
  timesheet: "ساعات العمل",
  rolesManagement: "إدارة الأدوار",
  evaluations: "التقييمات",
  language: "EN",
  englishLang: "الإنجليزية (الولايات المتحدة الأمريكية)",
  arabicLang: "العربية (السعودية)",
  creatEvent: "إضافة فعالية",
  admins: "المديرين",
  addAdmin: "إضافة مدير",
  lookups: "العمليات",
  serviceProviderCategories: "فئات مقدمي الخدمات",
  serviceProviders: "مقدمي الخدمات",
  specialties: "التخصصات",
  services: "الخدمات",
  logout: "تسجيل الخروج",
  lang: "English",
  back: "الرجوع",
  search: "ابحث عن موظف",
  searchCountry: "ابحث عن دولة",
  noSearch: "لا توجد نتائج مطابقة لبحثك",
  noData: "لا توجد بيانات حتى الان",
  actions: "أفعال",
  edit: "تعديل",
  view: "تفاصيل",
  delete: "حذف",
  add: "إضافة",
  save: "حفظ",
  submit: "ارسال",
  loading: "جاري التحميل...",
  savedChanging: "تم حفظ التغييرات",
  Notifiable: "قابل للإخطار",
  EditProfile: "تعديل الملف الشخصي",
  cancel: "الغاء",
  close: "إغلاق",
  filter: "تصنيف",
  confirm: "تأكيد",
  approve: "قبول",
  addNote: "إضافة ملاحظة",
  editNote: "تعديل ملاحظة",
  deleteNote: "حذف ملاحظة",
  stcNumber: "رقم STC",
  phone_number: "رقم الهاتف",
  editProfile: "تعديل الملف الشخصي",
  dailyAmount: "المبلغ اليومي",
  totalAmount: "إجمالي المبلغ",
  numberOfWorkingDays: "عدد أيام العمل",
  block: "حظر",
  unBlock: "الغاء الحظر",
  blocked: "محظور",
  none: "لا يوجد !",
  id: "رقم الهوية",
  note: "ملاحظة",
  viewMore: "مشاهدة المزيد",
  addYourNote: "أضف ملاحظاتك",
  // For user modules:
  clientSurvey: "استطلاع رأي العميل",
  heatMap: "الخريطة الحرارية",
  clients: "العملاء",
  companies: "الشركات",
  registrationRequestsMenu: "طلبات التسجيل",
  demoRequestsMenu: "طلبات تجريبية",
  profileEditRequestsMenu: "طلبات تعديل الملف",
  publishingRequestsMenu: "طلبات النشر",
  companiesListMenu: "الشركات",
  clientsManagement: "إدارة العملاء",
  manageReports: "إدارة التقارير",
  surveryScore: "درجة الاستبيان",
  scoreNotFound: "لم يتم العثور على النتيجة",
  lists: {
    enTitle: "الاسم بالانجليزية",
    arTitle: "الاسم بالعربية",
    enName: "الاسم بالانجليزية",
    arName: "الاسم بالعربية",
    name: "الاسم",
    phone: "رقم الهاتف",
    image: "الصورة",
    email: "البريد الالكتروني",
    categories: "الفئات",
    status: "الحالة",
  },
  noHavePermission: "ليس لديك أي أذونات حتى الآن",
  filesAccepted: "الحجم الأقصى: 5MB، التنسيقات المقبولة: jpg، jpeg، png، و bmp",
  uploadTypeError: "التنسيقات المقبولة هي jpg و jpeg و png و bmp فقط",
  uploadSizeError: "اقصي حجم 5MB",
  uiUploadInvalidType: "التنسيقات المقبولة: JPG و PNG و SVG",
  uiUploadMaxSize: "الحجم الأقصى للملف {size}",
  acceptedFormatLabel: "التنسيقات المقبولة",
  noOptions: "لا يوجد خيارات",
  pdfUploadTypeError: "الصيغة المقبولة هي pdf فقط",
  pdfUploadSizeError: "الحجم الأقصى 5MB",
  dynamicTableActions: {
    columnMenuShowColumns: "عرض القوائم",
    columnsPanelTextFieldLabel: "ابحث عن قائمة",
    columnsPanelTextFieldPlaceholder: "عنوان القائمة",
    columnsPanelShowAllButton: "عرض الكل",
    columnsPanelHideAllButton: "إخفاء الكل",
    columnMenuLabel: "قائمة",
  },
  role: "الوظيفه",
  gender: "الجنس",
  male: "ذكر",
  female: "أنثى",
  notProvided: "غير مزود",
  noInternetConnection: "لا يوجد اتصال بالإنترنت",
  generalErrMsg: "عذرا, لقد حدث خطأما!",
  cm: "سم",
  kg: "كجم",
  genderOptions: {
    male: "ذكر",
    female: "أنثى",
    prefer_not_to_say: "غير مُزود",
  },
  status: "الحالة",
  image: "الصورة",
  eventStatusOptions: {
    ongoing: "الحاليه",
    upcoming: "القادمه",
    past: "مكتمل",
    pending: "قيد الانتظار",
    canceled: "ملغيه",
    draft: "مسودة",
    pending_payment: "قيد الانتظار",
  },
  hint: "لتغيير الوظيفه قبل القبول برجاء التغيير من قائمه الوظائف",
  sar: "ر.س",
  other: "آخر",
  location: "الموقع",
  meter: "متر",
  minutes: "دقائق",
  workingDurationHour: "ساعة",
  workingDurationMinute: "دقيقة",
  select: "اختر",
  numberOfRows: "عدد الصفوف",
  dateInputFormatPlaceholder: "يوم/شهر/سنة",
  invite: "ادعو",
  selected: "تم اختيار",
  outOf: "من أصل",
  all: "الكل",
  locationError: "أدخل اسم الموقع بأقل من 20 حرفًا",
  locationPlaceholderOther: "أدخل خيارًا آخر",
  selectedLocation: "--اختر الموقع--",
  selectedReason: "--اختر السبب--",
  sureMessage: "هل أنت متأكد أنك تريد حذف هذا الموقع؟",
  listBreadCrumbs: {
    listJoiningBreadcrumb: "الفعاليات الانضمامية",
    listPayrollBreadcrumb: "فعاليات الرواتب",
    listReportsBreadcrumb: "تقارير الفعاليات",
    heatMap: "الخرائط الحرارية",
    reports: "التقارير",
    surveyScore: "درجات الاستبيان",
  },
  promoteToAdmin: "ترقية إلى مسؤول",
  demoteToAdmin: "خفض إلى مسؤول",
  adminPrivileges: "صلاحيات المسؤول",
  accessRights:
    "عذرًا، ليس لديك حقوق وصول. يرجى الاتصال بالمسؤول super_admin@example.com",
  downloadAll: "تحميل الكل",
  download: "تنزيل",
  expandImageFullSize: "عرض الصورة بالحجم الكامل",
  closeImageViewer: "إغلاق العارض",
  uploadFile: "تحميل الملف",
  uploadedSuccessfully: "تم رفع الملف بنجاح",
  removeFile: "إزالة الملف",
  report_desp:
    "قم باختيار أحد الأحداث أدناه لعرض المستندات الموجودة داخل كل استعلام.",
  addShift: "إضافة التحول",
  date: "تاريخ",
  selectDate: "اختر التاريخ",
  am: "ص",
  pm: "م",
  shiftTypes: {
    morning_shift: "الوردية الصباحية",
    evening_shift: "الوردية المسائية",
    night_shift: "الوردية الليلية",
    full_time: "دوام كامل",
    morning: "صباحي",
    evening: "مسائي",
    night: "ليلي",
    fullTime: "دوام كامل",
    Morning: "صباحي",
    Evening: "مسائي",
    Night: "ليلي",
    Full_Time: "دوام كامل",
  },
  joined: "انضم في",
  dashboard: "لوحة التحكم",
  settings: "الإعدادات",
  companyPortalProfile: "الملف الشخصي",
  companyPortalTeamPermissions: "الفريق والصلاحيات",
  companyPortalLoyalApplicants: "المتقدمون الموالون",
  companyPortalRolesManage: "إدارة الأدوار",
  companyPortalSecurity: "الأمان",
  security: "الأمان",
  companyPortalCountry: "الدولة",
  companyPortalAccountStatus: "حالة الحساب",
  companyPortalLanguage: "اللغة",
  companyPortalProfileVerified: "مُتحقق",
  companyPortalProfileUnverified: "غير مُتحقق",
  editRequestBanner: {
    approved: "تمت الموافقة على طلب التعديل الخاص بك بنجاح",
    declined: "تم رفض طلب التعديل الخاص بك",
    pending: "تم إرسال طلب التعديل الخاص بك وهو قيد المراجعة",
    reviewing:
      "طلب التعديل الخاص بك قيد المراجعة حالياً. سيتم إخطارك بمجرد الموافقة عليه.",
    actions: {
      dismiss: "تجاهل",
      viewDetails: "عرض التفاصيل",
      cancelRequest: "إلغاء الطلب",
      editRequest: "تعديل الطلب",
    },
    editProfileLocked:
      "لا يمكنك تعديل الملف الشخصي أثناء مراجعة الطلب أو بعد معالجته.",
    cancelConfirmDialog: {
      title: "إلغاء الطلب",
      message:
         "هل أنت متأكد أنك تريد إلغاء الطلب؟",
      no: "لا",
      yes: "نعم",
    },
  },
};

export default shared;
